var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt-close",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,0",
    fill: "none",
    stroke: "#54e046",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M163.081,161.9a.833.833,0,1,1-1.178,1.178l-2.5-2.5-2.5,2.5a.833.833,0,1,1-1.178-1.178l2.5-2.5-2.5-2.5a.833.833,0,1,1,1.178-1.178l2.5,2.5,2.5-2.5a.833.833,0,1,1,1.178,1.178l-2.5,2.5Zm0,0",
    transform: "translate(-149.398 -149.397)",
    fill: "#54e046"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtClose);
export default __webpack_public_path__ + "static/media/bt-close.1adb36a5f09ca7a72035dc77f78c1a6a.svg";
export { ForwardRef as ReactComponent };